// extracted by mini-css-extract-plugin
export default {"activePowerTable":"TimeIntervalTable_activePowerTable__Yd+rY"};